import {
	SHOW_ADD_CARD,
	HIDE_ADD_CARD,
	SHOW_EDIT_CARD,
	HIDE_EDIT_CARD,
	SHOW_DELETE_CARD,
	HIDE_DELETE_CARD,
	UPDATE_CARD,
	UPDATE_CARDS,
	UPDATE_CUSTOMER,
	CLEAR_CARD,
	CLEAR_CARDS,
	CLEAR_CUSTOMER,
	UPDATE_CUSTOMER_CARD,
	ADD_CUSTOMER_CARD,
	UPDATE_INVOICE,
	UPDATE_INVOICES,
	ADD_CHARGE,
	UPDATE_CHARGE,
	UPDATE_CHARGES
} from 'constants';

import { callApi } from 'api';
import { notify } from 'actions';

export const showAddCard = () => {
	return {
		type : SHOW_ADD_CARD
	}
}

export const showEditCard = () => {
	return {
		type : SHOW_EDIT_CARD
	}
}

export const showDeleteCard = () => {
	return {
		type : SHOW_DELETE_CARD
	}
}
export const hideAddCard = () => {
	return {
		type : HIDE_ADD_CARD
	}
}

export const hideEditCard = () => {
	return {
		type : HIDE_EDIT_CARD
	}
}

export const hideDeleteCard = () => {
	return {
		type : HIDE_DELETE_CARD
	}
}
export const updateCard = (card) => {
	return {
		type : UPDATE_CARD,
		card
	}
}

// export const updateCards = (cards) => {
// 	return {
// 		type : UPDATE_CARDS,
// 		cards
// 	}
// }

export const clearCard = () => {
	return {
		type : CLEAR_CARD
	}
}

// export const clearCards = () => {
// 	return {
// 		type : CLEAR_CARDS
// 	}
// }


export const updateCustomer = (customer) => {
	return {
		type : UPDATE_CUSTOMER,
		customer
	}
}

export const updateCustomerCard = (card) => {
	return {
		type : UPDATE_CUSTOMER_CARD,
		card
	}
}

export const addCustomerCard = (card) => {
	return {
		type : ADD_CUSTOMER_CARD,
		card
	}
}

export const clearCustomer = () => {
	return {
		type : CLEAR_CUSTOMER
	}
}

export const updateInvoice = (invoice) => {
	return {
		type : UPDATE_INVOICE,
		invoice
	}
}

export const updateInvoices = (invoices) => {
	return {
		type : UPDATE_INVOICES,
		invoices
	}
}

export const updateCharge = (charge) => {
	return {
		type : UPDATE_CHARGE,
		charge
	}
}

export const updateCharges = (charges) => {
	return {
		type : UPDATE_CHARGES,
		charges
	}
}

export const getCustomer = (callback) => {
	return (dispatch, getState) => {
		callApi('GET', '/account/customer', null)
			.then(customer => {
				dispatch(updateCustomer(customer));
				if(typeof callback === 'function') {
					return callback(null, customer);
				}
			})
			.catch(error => dispatch(notify(error)))
	}
}

export const setDefaultSource = (id, callback) => {
	return (dispatch, getState) => {
		callApi('PUT', '/account/source/make-default', { id }, 'application/json')
			.then(customer => {
				dispatch(updateCustomer(customer));
				if(callback)
					callback(null, customer);
			})
			.catch(error => {
				dispatch(notify(error));
				if(callback)
					callback(error, null);
			});
	}
}

export const getCharges = (settings, callback) => {
	var {limit, starting_after} = settings;
	return (dispatch, getState) => {
		callApi('POST', '/account/charges', { limit, starting_after }, 'application/json')
			.then(charges => {
				dispatch(updateCharges(charges));
				if(callback)
					callback(null, charges);
			})
			.catch(error => {
				dispatch(notify(error));
				if(callback)
					callback(error, null);
			});
	}
}

export const getInvoices = (callback) => {
	return (dispatch,getState)=>{

	}
}

export const createCard = (card, callback) => {
	return (dispatch, getState) => {
		callApi('POST', '/account/source', card, 'application/json')
			.then(card => {
				if(typeof callback === 'function')
					callback(null,card);
			})
			.catch(error => {
				if(typeof callback === 'function')
					callback(error,null)
			});
	}
}
export const editCard = (card, callback) => {
	return (dispatch, getState)	=>	{
		callApi('PUT', '/account/source', card, 'application/json')
			.then(card => {
				if(typeof callback === 'function')
					callback(null,card);
			})
			.catch(error => {
				if(typeof callback === 'function')
					callback(error,null);
			});
	}
}

export const  deleteCard = (card, callback) => {
	return (dispatch, getState)=>{
		callApi('DELETE', '/account/source', card, 'application/json')
			.then(confirmation => {
				if(callback)
					callback(null,confirmation);
			})
			.catch(error => {
				if(callback)
					callback(error,null);
			});
	}
}

export const purchaseMap = (map, callback) => {
	return (dispatch, getState) => {
		callApi('POST', '/account/purchase/map', map, 'application/json')
			.then(charge => {
				if(callback)
					callback(null,charge);
			})
			.catch(error => {
				if(callback)
					callback(error,null);
			})
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/account.js